import { createElement } from 'react'
import {render} from 'react-dom'
import {
  BlogTeaserList,
  EETeaserClicktracking,
  BannerSwiper,
  SubscribeForm,
} from '../homepage'
import { mountOnId } from 'shared'
import { ProjectSwiper } from 'modules'

document.addEventListener("DOMContentLoaded", () => {
  const mountBanners = document.getElementById('mount-homepages-banners')
  if (mountBanners) {
    const banners = JSON.parse(mountBanners.getAttribute('data-banners'))
    const bannerComponent = createElement(BannerSwiper, { banners })
    render(bannerComponent, mountBanners)
  }

  mountOnId(BlogTeaserList, 'homepages-blog-teaser')

  const swipers = document.querySelectorAll('[data-behavior="project-swiper"]')
  Array.from(swipers).forEach(function (el) {
    const featured = createElement(ProjectSwiper, el.dataset)
    render(featured, el)
  })

  mountOnId(SubscribeForm, 'mount-homepages-newsletter-form')

  new EETeaserClicktracking()
})
